// extracted by mini-css-extract-plugin
module.exports = {"w288":"index_w288__3thrG","w440":"index_w440__2HbFF","center_w0":"index_center_w0__2qppt","center_w1":"index_center_w1__3QemD"};